import { queryOptions } from '@tanstack/react-query';
import { createServerFn } from '@tanstack/react-start';
import z from 'zod';

const getSettingsSchema = z.object({
  conversationId: z.string(),
});

export const getConversationSettingsFn = createServerFn({ method: 'GET' })
  .validator(getSettingsSchema)
  .handler(async ({ data }) => {
    const { getConversationSettings } = await import('./getConversationSettings.server');
    return getConversationSettings(data.conversationId);
  });

export const conversationSettingsQueryOptions = (conversationId: string) =>
  queryOptions({
    queryKey: ['conversationSettings', conversationId],
    queryFn: () => getConversationSettingsFn({ data: { conversationId } }),
  });
